// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__tTlw1","content":"Layout_content__r6CZ7","logged_in":"Layout_logged_in__b7XiY","page":"Layout_page__3LQV2"};